package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.pages.components.checkout.CheckoutTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.CashRegisterConfigContent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.css.px

@Composable
fun CashRegisterConfiguration(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
)
{
    LaunchedEffect(Unit){
        event(OptionsEvent.GetApaleoProperties)
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .overflow(Overflow.Auto)
    )
    {
        if (windowSizeMode== WindowSizeModeEnum.PHONE) {
            if (state.firstPageActive) {
                CheckoutTabContent(
                    borderLess = true,
                    fillMaxWidth = true,
                    selectedId = state.selectedCashRegisterConfigItemId,
                    showCheckBoxes = false,
                    cashList =state.cashList,
                    padding = 0.px,
                    cashRegisterIds = listOf(),
                    windowSizeMode = windowSizeMode,
                    updateCheckout = {},
                    isExpandAll = true,
                    searchValue ="" ,
                    showAddIcon = true,
                    onSearchValueChange = {
                        event(OptionsEvent.OnSearchCheckoutItems(it))
                    },
                    onItemClick = {
                        event(OptionsEvent.OnCashRegisterConfigItemClick(it))
                    },
                    onAddCashRegisterClick = {
                        event(OptionsEvent.SetAddNewDeviceToCashRegistersDialogStatus(true))
                    }
                )
            } else {
                CashRegisterConfigContent(
                    state = state,
                    event = event,
                    windowSizeMode = windowSizeMode,
                )
            }
        } else {
            CheckoutTabContent(
                borderLess = true,
                fillMaxWidth =false,
                width = Dimen.checkOutItemWidth,
                showCheckBoxes = false,
                selectedId = state.selectedCashRegisterConfigItemId,
                padding = 0.px,
                cashList =state.cashList,
                cashRegisterIds = listOf(),
                windowSizeMode = windowSizeMode,
                updateCheckout = {},
                isExpandAll = true,
                searchValue ="" ,
                showAddIcon = true,
                onSearchValueChange = {
                    event(OptionsEvent.OnSearchCheckoutItems(it))
                },
                onItemClick = {
                    event(OptionsEvent.OnCashRegisterConfigItemClick(it))
                },
                onAddCashRegisterClick = {
                    event(OptionsEvent.SetAddNewDeviceToCashRegistersDialogStatus(true))
                }
            )

            CashRegisterConfigContent(
                state =state,
                event =event,
                windowSizeMode =windowSizeMode,
            )
        }
    }
}



